import { default as Axios } from "axios";
import { jwtAuthAxios } from "../../shared/utils/network-utils";
import { TranslateOsmTag } from "../models/TranslateOsmTag";

const prefix = "/admin/osm";

export const AdminOsmApi = {
  queryPolygon: async (body: { polygon: number[][]; cityId: string }) =>
    await jwtAuthAxios().post<string>(`${prefix}/query`, body),

  searchPolygon: async (city: string, country: string) => {
    const params = new URLSearchParams({
      city,
      country,
      format: "geojson",
      polygon_geojson: "1",
      polygon_threshold: "0.003",
      limit: "1",
    });

    const url = `https://nominatim.openstreetmap.org/search?${params.toString()}`;
    return await Axios.get<GeoJSON.FeatureCollection>(url);
  },

  translateTag: async (body: TranslateOsmTag) =>
    await jwtAuthAxios().post<null>(`${prefix}/translate-tag`, body),
};
